export const ucfirst = (str) => {
    return str ? str[0].toUpperCase() + str.substring(1) : '';
};
